import { Banner, isPromptBanner } from '../types/banner';

const SplitPrompt = (prompt: string) => {
  return prompt.split(' ').slice(0, 7).join(' ') + '...';
};

export const getDisplayContent = (banner: Banner): string => {
  if (isPromptBanner(banner)) {
    return banner.title || 'Nuevo asset';
  }

  // Para creatividades en general
  return banner.title || `Banner ${banner.bannerType}`;
};
